import { useEffect } from "react";

import { ApiService } from "Services/api";

export const useFetchManagerInfo = (handler) => {
  useEffect(() => {
    async function fetch() {
      const info = await ApiService.get("/manager_info/");
      handler(info);
    }
    fetch();
  }, [handler]);
};
